import AdminDiscussionItem from 'shared/components/admin_discussion_item';
import Discussion from 'shared/components/discussion';

export default class AdminDiscussion extends Discussion {
  constructor() {
    super();

    this.ui.itemAdmin = '.livestreaming-discussion-item--admin';
    this.ui.muteAllButton = ".livestreaming-discussion-item__mute-all-button";
    this.ui.muteButton = ".livestreaming-discussion-item__mute-button";
    this.setupPinMessageComponent();
  }

  init() {
    Discussion.prototype.init.call(this);
    this.bindMuteResponse();
  }

  setupPinMessageComponent(){
    this.selector = {
      input: $('.livestreaming-discussion__input[type="text"]')
    };
  }

  add(comment) {
    if ($(this.ui.item +'[data-id="' + comment.id + '"]').length === 0) {
      var item = AdminDiscussionItem.new(comment, this.current_username);
      $(this.ui.content).append(item.html);
    }
  }

  bindMuteResponse() {
    $(this.ui.content).on("ajax:success", this.ui.muteAllButton, () => this.displaySuccessMuteAll());
    $(this.ui.content).on("ajax:error", this.ui.muteAllButton, () => this.displayErrorMute());

    $(this.ui.content).on("ajax:success", this.ui.muteButton, () => this.displaySuccessMute());
    $(this.ui.content).on("ajax:error", this.ui.muteButton, () => this.displayErrorMute());
  }

  displaySuccessMute() {
    window.alert('User berhasil di-mute untuk livestream ini');
  }

  displayErrorMute() {
    window.alert('Gagal me-mute user');
  }

  displaySuccessMuteAll() {
    window.alert('User berhasil di-mute untuk semua livestream');
  }
}
